$(function () {
    $('#service-card-01').on('click', function () {
        var show = document.querySelector('#service-card-01').classList.contains('show');
        if (show) {
            $('#service-card-01').removeClass('show');
            $('#service-card-01 .content').slideUp();
        } else {
            $('#service-card-01').addClass('show');
            $('#service-card-01 .content').slideDown();
        }
    });

    $('#service-card-02').on('click', function () {
        var show = document.querySelector('#service-card-02').classList.contains('show');
        if (show) {
            $('#service-card-02').removeClass('show');
            $('#service-card-02 .content').slideUp();
        } else {
            $('#service-card-02').addClass('show');
            $('#service-card-02 .content').slideDown();
        }
    });

    $('#service-card-03').on('click', function () {
        var show = document.querySelector('#service-card-03').classList.contains('show');
        if (show) {
            $('#service-card-03').removeClass('show');
            $('#service-card-03 .content').slideUp();
        } else {
            $('#service-card-03').addClass('show');
            $('#service-card-03 .content').slideDown();
        }
    });

    $('#service-card-04').on('click', function () {
        var show = document.querySelector('#service-card-04').classList.contains('show');
        if (show) {
            $('#service-card-04').removeClass('show');
            $('#service-card-04 .content').slideUp();
        } else {
            $('#service-card-04').addClass('show');
            $('#service-card-04 .content').slideDown();
        }
    });
});